require('./src/modal.module');
require('./src/components/modal.provider');
require('./src/config/modal.config');
require('./src/config/modal.default.constant');
require('./src/config/modal.types.constant');
require('./src/controllers/modal.controller');
require('./src/css/styles.modal.scss');
require('./src/directives/ac.modal.drag.directive');
require('./src/directives/ac.modal.resize.directive');
require('./src/templates/modal.templates');